<template>
  <section class="view">
    <div class="row">
      <div class="col-md-3 pr-0">
        <div class="card mb-0">
          <div class="card-body">
            <div class="text-value">{{ !isNaN(complete) ? complete : '' }}% COMPLETE</div>

            <div class="progress progress-xs my-2">
              <div class="progress-bar bg-success" role="progressbar"
                v-bind:style="{ width: !isNaN(complete) ? complete + '%' : '' + '%' }"
                :aria-valuenow="!isNaN(complete) ? complete : ''" aria-valuemin="0" aria-valuemax="100">
              </div>
            </div>
            <div>
              <button class="btn btn-sm mr-1 text-center status" @click="setStatus(stt)"
                v-for="(stt, key) in checklist_item_status" :key="key"
                v-bind:style="{ width: '35px', background: check(stt) ? stt.color : '', color: check(stt) ? '#fff' : '' }"
                v-b-tooltip.hover :title="stt.name">{{ stt.code }}</button>
              <button class="btn btn-sm text-center status" @click="setStatus(null)"
                v-bind:style="{ width: '35px', background: select_status.length == 0 ? 'red' : '', color: select_status.length == 0 ? '#fff' : '' }">All</button>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header px-3 py-2 bg-info">
            Trạng thái cuộc đánh giá: {{ checklist.status ? checklist.status.name : '' }}
            <span class="pull-right mr-3 search" @click="toggleSearch">
              <i class="fa fa-search"></i> Tìm kiếm
            </span>
          </div>

          <div class="card-body" style="padding: 0px">
            <div v-if="showSearch" class="m-1">
              <input type="text" class="form-control" placeholder="Search" v-model="txt_search">
            </div>
            <div v-if="!data.length">
              {{ $t('common.nodata') }} <br>
              <span class="link" @click="addGroupChecklistItem"
                v-if="!data.length && select_status.id == 0">
                <i class="fa fa-pencil"></i>
                {{ $t('checklist.attribute.add_group') }} checklist-item
              </span>
            </div>
            <Tree :data="data" cross-tree="cross-tree" class="scroll" id="tree-grp">
              <div slot-scope="{data, level, store}">
                <template v-if="!data.isDragPlaceHolder">
                  <div class="node" @click="select(data)" v-bind:class="{ select: data.id == select_group.id }"
                    :id="'node-' + data.id" :ref="'node-' + data.id"
                    v-bind:style="{ cursor: data.total ? '' : 'not-allowed' }">
                    <span class="pull-right" v-if="data.total">
                      ({{ data.is_check }}/{{ data.total }})
                    </span>
                    <span v-html='data.index'></span> {{ data.header }}
                  </div>
                </template>
              </div>
            </Tree>
          </div>
        </div>
      </div>
      <div class="col-md-9 pl-0">
        <div class="card">
          <div class="card-header px-3 py-2 bg-info">
            {{ checklist.name }} ({{ checklist.organization ? checklist.organization.name : '' }})
            <b-dropdown class="float-right" variant="transparent" right>
              <template slot="button-content">
                <i class="icon-settings"></i>
                {{ $t('checklist.attribute.action') }}
              </template>
              <b-dropdown-item @click="information()">
                <i class="fa fa-info"></i>{{ $t('checklist.attribute.information') }}</b-dropdown-item>
              <b-dropdown-item @click="summary()">
                <i class="fa fa-list-ul"></i>Nhập kết luận đánh giá
              </b-dropdown-item>
              <b-dropdown-item @click="auditResult()">
                <i class="fa fa-print"></i>Xem kết quả đánh giá
              </b-dropdown-item>
              <b-dropdown-item @click="printChecklist(checklist)">
                <i class="fa fa-print" aria-hidden="true"></i>In kết quả đánh giá
              </b-dropdown-item>
              <b-dropdown-item @click="historySummary()">
                <i class="fa fa-history"></i>{{ $t('checklist.attribute.history_summary')
                }}</b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="card-body p-0">
            <OverviewChk v-if="Object.keys(select_group).length === 0" :checklist="checklist"
            :team="groupedData" :quick_reports="quick_reports"/>
            <checklist-item ref="checklist_item" :checklist_item_status="checklist_item_status"
              :checklist_items="checklist_items" v-show="Object.keys(select_group).length !== 0"><span
                v-html="select_group.index"></span>
              {{ select_group.header }}</checklist-item>
          </div>
        </div>
      </div>
    </div>
    <statistic ref="statistic"></statistic>
    <div class="page" id="page" v-show="false">
      <div class="header row" style="border-bottom: black solid 2px">
        <div class="col-md-6">
          <img src="/static/petrolimexaviation.jpg" class="img-responsive" alt="Image" style="width: 349px">
        </div>
        <div class="col-md-6">
          <span class="pull-right text-uppercase" style="font-weight: bold;">
            Cuộc đánh giá:
          </span>
        </div>
      </div>
      <div class="body row mt-3">
        <div class="col-md-12 text-center text-uppercase">
          <b>{{ checklist.name }} {{ checklist.organization ? checklist.organization.name : '' }}</b>
        </div>
      </div>
      <div class="row mt-3 mr-1 ml-1" v-for="(item, index) in data_print" :key="index">
        <p><b v-if="item.group">{{ item.group.index }} - {{ item.group.header }}</b></p>
        <div class="table-responsive" v-if="item.chk_item.length != 0">
          <table class="table table-hover">
            <thead class="thead-light">
              <tr>
                <th>ID</th>
                <th>{{ $t('checklist-item.attribute.content') }}</th>
                <th>{{ $t('summary.refer') }}</th>
                <th>{{ $t('checklist-item.attribute.status') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(chk_item, key) in item.chk_item" :key="key">
                <td style="width: 10%">{{ chk_item.header }}</td>
                <td style="width: 80%">
                  <span v-html="chk_item.content"></span>
                </td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { DraggableTree } from 'vue-draggable-nested-tree'
import ChecklistItem from './checklist-item'
import AlertChecklist from '@/components/alert-checklist'
import Statistic from './statistic'
import OverviewChk from './overviewChk'
import swal from 'sweetalert'
import StatusCode from '@/status'
import lodash from 'lodash'
import { scroller } from 'vue-scrollto/src/scrollTo'
import { getAssessmentTeam } from '@/service/Apis'
import Helper from '@/Helper'
export default {
  name: 'views',
  components: {
    Tree: DraggableTree,
    ChecklistItem,
    OverviewChk,
    AlertChecklist,
    Statistic
  },
  props: [],
  data () {
    return {
      data_print: [],
      select_group: {},
      showSearch: false,
      txt_search: '',
      groupedData: [],
      checklistId: this.$route.params.checklist_id
    }
  },
  watch: {
    txt_search (newSearch, old) {
      this.sss()
    }
  },
  created: function () {
    this.sss = lodash.debounce(this.search, 500)
  },
  computed: {
    data () {
      return this.$store.getters['Audit/getGroupOfChecklist']
    },
    checklist_items () {
      return this.$store.getters['Audit/getChecklistItemOfGroupChecklist']
    },
    checklist () {
      return this.$store.getters['Checklist/showChecklist']
    },
    checklist_item_status () {
      return this.$store.getters['ChecklistItemStatus/getListStatus']
    },
    quick_reports () {
      return this.$store.getters['Audit/getQuickReport']
    },
    select_status () {
      return this.$store.getters['Audit/getSelectStatus']
    },
    complete () {
      return this.$store.getters['Audit/getComplete']
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.$store.dispatch('Audit/clearSelectStatus')
    if (to.query.grp) {
      this.select_group = { id: to.query.grp }
    }
    Promise.all([
      this.$store.dispatch('Audit/getGroupOfChecklist', { checklist: { id: to.params.checklist_id }, select_status: this.select_status }),
      this.$store.dispatch('Audit/getChecklistItemOfGroupChecklist', { checklist: { id: to.params.checklist_id }, group_checklist_item: { id: to.query.grp }, select_status: this.select_status }),
      this.$store.dispatch('Checklist/showChecklist', { checklist: { id: to.params.checklist_id } }),
      this.$store.dispatch('ChecklistItemStatus/getListStatus'),
      this.$store.dispatch('Audit/quickReport', { checklist: { id: to.params.checklist_id } })
    ]).then(res => {
      var container = document.getElementById('tree-grp')
      var idScroll = 'node-' + to.query.grp
      var offsetTop = document.getElementById(idScroll).offsetTop - 100
      container.scrollTo({ top: offsetTop })

      next()
    }).catch(errors => {
    })
  },
  mounted () {
    this.fetchTeam()
    if (this.$route.query.grp) {
      this.select_group = { id: this.$route.query.grp }
      this.$store.dispatch('Audit/getChecklistItemOfGroupChecklist', { checklist: { id: this.checklistId }, group_checklist_item: { id: this.$route.query.grp }, select_status: this.select_status }).then(res => {
        scroller()('#id' + this.$route.query.item)
      }).catch(errors => {

      })
    }
    this.$store.dispatch('Audit/clearSelectStatus')
    Promise.all([
      this.$store.dispatch('Audit/getGroupOfChecklist', { checklist: { id: this.checklistId }, select_status: this.select_status }),
      this.$store.dispatch('Checklist/showChecklist', { checklist: { id: this.checklistId } }),
      this.$store.dispatch('ChecklistItemStatus/getListStatus'),
      this.$store.dispatch('Audit/quickReport', { checklist: { id: this.checklistId } })
    ]).then(res => {
      var container = document.getElementById('tree-grp')
      var idScroll = 'node-' + this.$route.query.grp
      var offsetTop = document.getElementById(idScroll).offsetTop - 100
      container.scrollTo({ top: offsetTop })
    }).catch(errors => {
    })
  },
  methods: {
    async fetchTeam () {
      const res = await getAssessmentTeam(this.checklistId)
      this.groupedData = Helper.sortTeam(res.data)
    },
    select (groupChecklistItem) {
      console.log(groupChecklistItem)
      if (this.select_group.id === groupChecklistItem.id || groupChecklistItem.total === 0) {
        return false
      }
      this.showSearch = false
      this.$refs.checklist_item.start()
      this.$store.commit('Audit/getChecklistItemOfGroupChecklist', null)
      this.select_group = groupChecklistItem

      this.$store.dispatch('Audit/getChecklistItemOfGroupChecklist', { checklist: { id: this.checklistId }, group_checklist_item: groupChecklistItem, select_status: this.select_status }).then(res => {

      }).catch(errors => {
        console.log(errors)
      })
    },
    information () {
      Promise.all([
        this.$store.dispatch('Audit/quickReport', { checklist: { id: this.checklistId } })
      ]).then(res => {
        this.select_group = {}
      }).catch(errors => {
      })
    },
    summary () {
      this.$router.push('summary')
    },
    historySummary () {
      this.$router.push('summary/history')
    },
    auditResult () {
      this.$router.push('audit-result')
    },
    statistic () {
      this.$store.dispatch('Audit/quickReport', { checklist: { id: this.checklistId } }).then(res => {
        this.$refs.statistic.show(this.quick_reports)
      }).catch(errors => {

      })
    },
    addGroupChecklistItem () {
      if (parseInt(this.checklist.status.code) !== parseInt(StatusCode.SUBMITTING)) {
        swal({
          title: this.$t('checklist.error.add_group_checklist_item.title'),
          text: this.$t('checklist.error.add_group_checklist_item.text') + this.checklist.status.name,
          icon: 'warning'
        })
      } else {
        this.$router.push('checklist-item')
      }
    },
    setStatus (status) {
      if (!status) {
        this.$store.dispatch('Audit/clearSelectStatus')
      } else {
        this.$store.dispatch('Audit/setSelectStatus', status)
      }
      this.select_group = {}
      this.$store.dispatch('Audit/getGroupOfChecklist', { checklist: { id: this.checklistId }, select_status: this.select_status }).then(res => {
      }).catch(errors => {
      })
    },

    toggleSearch () {
      this.showSearch = !this.showSearch
    },

    search: function () {
      if (!this.txt_search) {
        return false
      }
      this.$store.commit('Audit/getChecklistItemOfGroupChecklist', null)
      this.select_group = { header: this.$t('checklist.search') + ' "' + this.txt_search + '"' }
      var vm = this
      vm.$store.dispatch('Audit/searchChecklist', { checklist: { id: vm.$route.params.checklist_id }, search: vm.txt_search }).then(res => {
        vm.checklist_items.map(item => {
          item.content = item.content.replace(new RegExp(vm.txt_search, 'gi'), '<span class="hightlighted">' + vm.txt_search + '</span>')
          item.header = item.header.replace(new RegExp(vm.txt_search, 'gi'), '<span class="hightlighted">' + vm.txt_search + '</span>')
          return item
        })
      }).catch(errors => {
      })
    },
    check (status) {
      var flag = false
      this.select_status.forEach(element => {
        if (parseInt(status.id) === parseInt(element.id)) {
          flag = true
        }
      })
      return flag
    },
    async printChecklist (checklist) {
      await this.$store.dispatch('Audit/getChecklistItemOfChecklist', { checklist }).then(res => {
        this.data_print = res
        console.log(this.data_print)

        this.$nextTick(() => {
          var innerContents = document.getElementById('page').innerHTML
          var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no')
          popupWinindow.document.open()
          popupWinindow.document.write('<html><head><link rel="stylesheet" href="/static/bootstrap.css"/><link rel="stylesheet" type="text/css" href="/static/print.css" /><link rel="stylesheet" type="text/css" href="/static/style.css" /></head><body onload="window.print()">' + innerContents + '</html>')
          popupWinindow.document.close()
        })
      }).catch(errors => {
      })
    }
  }
}
</script>
<style lang="scss">
#app {
  padding: 50px;
}

.node {
  border-bottom: 1px solid #ddd;
  padding: 10px;
  cursor: pointer;
}

.node:hover {
  background: #ddd
}

.select {
  background: #ddd
}

label {
  font-weight: 700
}

.search {
  cursor: pointer;
}

.search:hover {
  font-weight: bold
}
</style>



// WEBPACK FOOTER //
// src/views/checklist/view/index.vue